import React, { useEffect, useState } from "react";
import { ref, listAll, getDownloadURL } from "firebase/storage";
import { storage } from "../firebaseConfig";
import ro from "/src/content/ro.json";

const AntrenamenteOnline = ({
  title = ro.antrenamenteOnline.title,
  subtitle = ro.antrenamenteOnline.subtitle,
  cost = ro.antrenamenteOnline.costValue,
  sedinte = ro.antrenamenteOnline.sedinteValue,
}) => {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 Luăm pozele din Firebase Storage /imagini_admin
  useEffect(() => {
    const fetchImages = async () => {
      try {
        // dacă vrei doar un subfolder, ex: "imagini_admin/antrenamente_online/"
        // modifici linia de mai jos în consecință:
        const folderRef = ref(storage, "imagini_admin/");

        const res = await listAll(folderRef);

        const urls = await Promise.all(
          res.items.map((item) => getDownloadURL(item))
        );

        setGallery(urls);
        console.log("AO galerie – imagini găsite:", urls.length);
      } catch (err) {
        console.error("Eroare la încărcarea imaginilor AO:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  const handleInstagramClick = () => {
    window.open(
      "https://www.instagram.com/stefancelmare_ptrainerautm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <section id="antrenamente-online" className="ao-container">
      {/* Titlu */}
      <header className="ao-header">
        <h2 className="ao-title">{title}</h2>
        <p className="ao-kicker">{subtitle}</p>
      </header>

      {/* Zona principală */}
      <div className="ao-grid">
        {/* Imagine principală */}
        <figure className="ao-hero">
          <img
            src="/images/antrenanent_online.png"
            alt={ro.antrenamenteOnline.heroAlt}
            className="ao-hero-img"
          />
        </figure>

        {/* Card detalii */}
        <div className="ao-card">
          <ul className="ao-list">
            <li>
              <span className="ao-label">{ro.antrenamenteOnline.costLabel}</span>
              <span className="ao-value">{cost}</span>
            </li>
            <li>
              <span className="ao-label">{ro.antrenamenteOnline.sedinteLabel}</span>
              <span className="ao-value">{sedinte}</span>
            </li>
          </ul>

          <div className="ao-cta-row mt-2">
            <button className="ao-btn" onClick={handleInstagramClick}>
              {ro.antrenamenteOnline.cta}
            </button>
            <a href="#galerie" className="ao-link">
              {ro.antrenamenteOnline.galleryLink}
            </a>
          </div>
        </div>
      </div>

      {/* Galerie foto din Storage /imagini_admin */}
      <section id="galerie" className="ao-gallery">
        <h3 className="ao-gallery-title">{ro.antrenamenteOnline.galleryTitle}</h3>

        {loading ? (
          <p className="text-center text-gray-500">{ro.antrenamenteOnline.loading}</p>
        ) : gallery.length > 0 ? (
          <div className="ao-gallery-track">
            {gallery.map((src, i) => (
              <div key={i} className="ao-gallery-item">
                <img
                  src={src}
                  alt={`Galerie ${i + 1}`}
                  className="ao-gallery-img"
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-500">
            {ro.antrenamenteOnline.empty}
          </p>
        )}
      </section>
    </section>
  );
};

export default AntrenamenteOnline;
